import { useState } from "react";
import { Navigate, Link } from "react-router-dom";
import { Logo } from "../components/Logo";
import { useAuth, formatErr } from "../lib/auth";

export default function AdminLogin() {
  const { user, login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [err, setErr] = useState("");
  const [busy, setBusy] = useState(false);

  if (user) return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setErr("");
    try {
      await login(email, password);
    } catch (ex) {
      setErr(formatErr(ex.response?.data?.detail) || ex.message);
    } finally {
      setBusy(false);
    }
  };

  const input = "w-full bg-transparent border-b border-line py-3 focus:outline-none focus:border-[var(--gold)] transition-colors duration-300";

  return (
    <div className="min-h-screen grid place-items-center px-6" data-testid="admin-login-page">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="admin-login-form">
        <Link to="/" data-testid="admin-login-home-link"><Logo /></Link>
        <h1 className="font-display text-4xl mt-12">Espace admin</h1>
        <p className="text-stone mt-2 text-sm">Accès réservé · Restricted access</p>
        <div className="mt-10 space-y-6">
          <input data-testid="admin-email-input" type="email" placeholder="Email" className={input} value={email} onChange={(e) => setEmail(e.target.value)} />
          <input data-testid="admin-password-input" type="password" placeholder="Mot de passe / Password" className={input} value={password} onChange={(e) => setPassword(e.target.value)} />
        </div>
        {err && <p className="mt-6 text-sm text-red-400" data-testid="admin-login-error">{err}</p>}
        <button data-testid="admin-login-submit" disabled={busy} className="mt-10 w-full rounded-full bg-[var(--gold)] text-[var(--ink)] py-3.5 font-semibold hover:bg-[var(--gold-2)] disabled:opacity-60 transition-colors duration-300">
          {busy ? "…" : "Se connecter"}
        </button>
      </form>
    </div>
  );
}
